import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { projectsRetrieveSinceStart } from "Store/Actions";
import { IAction } from "./IAction";

export function useRefresh(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();

  const onRefresh = useCallback(async () => {
    await preflightAuthentication();
    dispatch(projectsRetrieveSinceStart(true));
  }, [dispatch, preflightAuthentication]);

  return [true, onRefresh];
}
